"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Badge = function Badge(_ref) {
  var isSmall = _ref.isSmall,
    color = _ref.color,
    children = _ref.children,
    uniqueID = _ref.uniqueID;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('agillicBadge', color, {
      small: isSmall
    }),
    "data-testid": uniqueID
  }, _react.default.createElement("span", null, children));
};
Badge.propTypes = {
  isSmall: _propTypes.bool,
  color: (0, _propTypes.oneOf)(['grey', 'red', 'green', 'lightGreen', 'blue', 'orange', 'darkOrange', 'purple', 'yellow']).isRequired,
  children: _propTypes.string.isRequired,
  uniqueID: _propTypes.string
};
Badge.defaultProps = {
  color: 'grey'
};
var _default = Badge;
exports.default = _default;